import React from 'react';
import { withRouter } from 'react-router-dom';
import { MonetizationOnRounded as FaturaIcon } from '@material-ui/icons';

import {
    makeStyles,
    Card,
    CardHeader,
    CardContent,
    Typography,
    Avatar,
    CardActions
} from '@material-ui/core';

import {
    MesEnum,
    MenuEnum
} from '../enums';

const useStyles = makeStyles(theme => ({
    card: {
        [theme.breakpoints.up('sm')]: {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        }
    },
    verDetalhes: {
        marginRight: 10,
        marginLeft: 'auto',
        color: theme.palette.primary[200]
    },
    avatar_1: {
        backgroundColor: theme.palette.success.main
    },
    avatar_2: {
        backgroundColor: theme.palette.error.main
    },
    avatar_3: {
        backgroundColor: theme.palette.warning.main
    },
    status_1: {
        color: theme.palette.success.main
    },
    status_2: {
        color: theme.palette.error.main
    },
    status_3: {
        color: theme.palette.warning.main
    },
    primary: {
        color: theme.palette.text.primary
    },
    disabled: {
        color: theme.palette.text.disabled
    },
    action: {
        alignSelf: 'auto',
        marginTop: 3
    },
    status: {
        marginRight: 10
    }
}));

function CardFaturamento(
    {
        faturamento,
        history
    }
) {
    const classes = useStyles();

    const handleClickDetalheFaturamento = (ano, mes) => {
        history.push({
            pathname: MenuEnum.properties[MenuEnum.FATURAS].path,
            state: { ano, mes }
        })
    }

    return (
        <Card className={classes.card}
            onClick={() => handleClickDetalheFaturamento(faturamento.anoReferencia, faturamento.mesReferencia)}>
            <CardHeader
                classes={{ action: classes.action }}
                avatar={
                    <Avatar aria-label="recipe" className={classes[`avatar_${faturamento.codigoSituacao}`]}>
                        <FaturaIcon />
                    </Avatar>
                }
                title={
                    <Typography variant='h5'
                        className={classes.primary}>
                        {MesEnum.properties[faturamento.mesReferencia].nome}
                        <Typography variant='caption'
                            className={classes.disabled}>
                            /{faturamento.anoReferencia}
                        </Typography>
                    </Typography>
                }
                action={
                    <Typography variant='caption'
                        className={`${classes.status} ${classes[`status_${faturamento.codigoSituacao}`]}`}>
                        {faturamento.descricaoSituacao}
                    </Typography>
                }
            />
            <CardContent>
                <Typography variant='overline'
                    className={classes.disabled}
                    component='p'
                    align='center'>
                    TOTAL DO FATURAMENTO
                </Typography>
                <Typography variant='h4'
                    className={classes.primary}
                    component='p'
                    align='center'>
                    R$ {faturamento.valorTotal.toLocaleString('pt-BR',
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Typography>
            </CardContent>
            <CardActions disableSpacing>
                <Typography variant='subtitle1'
                    className={classes.verDetalhes}>
                    Ver detalhes
                </Typography>
            </CardActions>
        </Card>
    );
}

export default withRouter(CardFaturamento);